const _UTILS = {
  async AddItemsToCart(items_to_add, sections) {
    // items_to_add = [{
    //   quantity: qty,
    //   id: variant_id,
    //   selling_plan: selling_plan_id,
    //   properties: {}
    // }]
    return await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        items: items_to_add,
        sections: sections ? sections : ['cart']
      })
    })
  }
}

/* 
Custom Carousel Play Pause Button
*/

var CarouselPlayPauseButton = class extends HTMLElement {
  #abortController;
  connectedCallback() {
    if (!this.carousel) {
      throw "Carousel prev button component requires an aria-controls attribute that refers to the controlled carousel.";
    }

    this.playing = this.getAttribute("autoplay") !== null;
    this.#abortController = new AbortController();
    this.addEventListener("click", () => this.handleClick(), { signal: this.#abortController.signal });
    this.playButton = this.querySelector("[data-play]");
    this.pauseButton = this.querySelector("[data-pause]");
    this.carousel.addEventListener("scroll:edge-nearing", (event) => this.firstElementChild.disabled = event.detail.position === "start", { signal: this.#abortController.signal });
    this.carousel.addEventListener("scroll:edge-leaving", (event) => this.firstElementChild.disabled = event.detail.position === "start" ? false : this.firstElementChild.disabled, { signal: this.#abortController.signal });
  }
  handleClick() {
    if(this.playing) {
      this.carousel.player.pause();
      this.playing = false;
      this.playButton.classList.remove('hidden');
      this.pauseButton.classList.add('hidden');
    } else {
      this.carousel.player.resume();
      this.playing = true;
      this.playButton.classList.add('hidden');
      this.pauseButton.classList.remove('hidden');
    }
    
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get carousel() {
    return document.getElementById(this.getAttribute("aria-controls"));
  }
};

if (!window.customElements.get("carousel-play-pause-button")) {
  window.customElements.define("carousel-play-pause-button", CarouselPlayPauseButton);
}

function handleQuestionAccessibility(element, questionId) {

  try {
    const questionChoices = Array.from(element.querySelectorAll('[data-option-id]') || []);
  
    const questionTitle = element.querySelector('.oct-quiz-title');
    const questionSubTitle = element.querySelector('.oct-quiz-subheading');
    const questionList = element.querySelector('ul');
  
    const labelId = `octane-question-label-${questionId}`;
    const labelElement = questionSubTitle || questionTitle;
    labelElement.setAttribute('id', labelId);
  
    questionList.setAttribute('aria-labelledby', labelId);
    questionList.setAttribute('role', 'group');
  
    questionChoices.forEach((choice) => {
      choice.setAttribute('role', 'button');
      choice.querySelectorAll("div:not(:first-child)").forEach((child) => {
        child.setAttribute('aria-hidden', 'true');
      });
    });
  } catch(e) {
    console.error('Error handling question accessibility:', e);
    return;
  }
}

document.addEventListener('octane.quiz.questionLoaded', function (e) {
   handleQuestionAccessibility(e.detail.quiz_wrapper_element, e.detail.question_id);
}, false);
